import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'style/style.scss';

ReactDOM.render(
  <App/>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js